import { render, staticRenderFns } from "./AddJobRolesSvg.vue?vue&type=template&id=4032cf18&scoped=true&"
import script from "./AddJobRolesSvg.vue?vue&type=script&lang=ts&"
export * from "./AddJobRolesSvg.vue?vue&type=script&lang=ts&"
import style0 from "./AddJobRolesSvg.vue?vue&type=style&index=0&id=4032cf18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4032cf18",
  null
  
)

export default component.exports